import { useEffect, useState, useCallback } from "react";
import { ChevronUp } from "lucide-react";

const SHOW_THRESHOLD_PX = 300;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > SHOW_THRESHOLD_PX);
        ticking = false;
      });
    };
    onScroll(); // initialise state in case the page is loaded scrolled
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      data-testid="back-to-top-button"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      style={{
        position: "fixed",
        bottom: "80px",
        right: "20px",
        zIndex: 55,
      }}
      className={`w-12 h-12 rounded-full flex items-center justify-center bg-[#C9A24E] text-[#0F172A] shadow-lg shadow-[#B8884A]/25 ring-1 ring-black/5 transition-all duration-300 ease-out hover:bg-[#B8884A] hover:text-white hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#B8884A]/35 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0F172A] ${
        visible ? "opacity-100 pointer-events-auto translate-y-0" : "opacity-0 pointer-events-none translate-y-2"
      }`}
    >
      <ChevronUp size={20} strokeWidth={2} />
    </button>
  );
}
